import { render, staticRenderFns } from "./InvoiceConfig.vue?vue&type=template&id=f39c4cde&scoped=true"
import script from "./InvoiceConfig.vue?vue&type=script&lang=js"
export * from "./InvoiceConfig.vue?vue&type=script&lang=js"
import style0 from "./InvoiceConfig.vue?vue&type=style&index=0&id=f39c4cde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f39c4cde",
  null
  
)

export default component.exports